import { APP_TOGGLE_MENU } from '../actionTypes';

export const toogleMenu = () => dispatch =>
  dispatch({
    type: APP_TOGGLE_MENU,
  });
